/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardOutcome } from './ScorecardOutcome.js';
import {
    ScorecardOutcomeFromJSON,
    ScorecardOutcomeFromJSONTyped,
    ScorecardOutcomeToJSON,
} from './ScorecardOutcome.js';
import type { ScorecardStatus } from './ScorecardStatus.js';
import {
    ScorecardStatusFromJSON,
    ScorecardStatusFromJSONTyped,
    ScorecardStatusToJSON,
} from './ScorecardStatus.js';

/**
 * 
 * @export
 * @interface UpdateScorecardRequest
 */
export interface UpdateScorecardRequest {
    /**
     * 
     * @type {ScorecardStatus}
     * @memberof UpdateScorecardRequest
     */
    status?: ScorecardStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateScorecardRequest
     */
    notes?: string;
    /**
     * 
     * @type {ScorecardOutcome}
     * @memberof UpdateScorecardRequest
     */
    outcome?: ScorecardOutcome;
}

/**
 * Check if a given object implements the UpdateScorecardRequest interface.
 */
export function instanceOfUpdateScorecardRequest(value: object): boolean {
    return true;
}

export function UpdateScorecardRequestFromJSON(json: any): UpdateScorecardRequest {
    return UpdateScorecardRequestFromJSONTyped(json, false);
}

export function UpdateScorecardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScorecardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ScorecardStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'outcome': json['outcome'] == null ? undefined : ScorecardOutcomeFromJSON(json['outcome']),
    };
}

export function UpdateScorecardRequestToJSON(value?: UpdateScorecardRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': ScorecardStatusToJSON(value['status']),
        'notes': value['notes'],
        'outcome': ScorecardOutcomeToJSON(value['outcome']),
    };
}

